module.exports = __webpack_public_path__ + "static/media/answer_epen@2x.d26b8ad2.png";